// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__PTnrF","headerWrapper":"style_headerWrapper__AL+d0","title":"style_title__GaIyb","img":"style_img__7F3Wu"};